import React from "react";
import Loader from "react-loader-spinner";
import RestaurantCard from "./RestaurantCard";

const Results = ({ restaurantList, loading, clickCard }) => {
  if (loading) {
    return (
      <div className="loader-container">
        <Loader type="ThreeDots" color="#231f20" height={50} width={50} />
      </div>
    );
  }

  return (
    <div>
      {restaurantList.map(restaurant => (
        <RestaurantCard
          clickCard={clickCard}
          key={restaurant.id || restaurant.mongodb_id}
          restaurant={restaurant}
        />
      ))}
    </div>
  );
};

export default Results;
